/**
 * Design tokens — Palette de couleurs et symboles astrologiques
 */

export const colors = {
  /** Doré principal (PHP --primaire) */
  accent:        '#c9a227',
  accentLight:   '#f5e6b3',
  accentLine:    '#e0b83a',
  accentHover:   '#b8921f',
  accentDark:    '#8a6d0a',

  bgSidebar:     '#fafafa',
  bgContent:     '#ffffff',
  bgPage:        '#fafafa',

  border:        '#e5e5e5',
  borderMid:     '#d5d5d5',

  text:          '#1a1a1a',
  textMid:       '#666666',
  textMuted:     '#999999',
  textLight:     '#b0b0b0',

  danger:        '#dc2626',
  dangerLight:   '#fef2f2',
  success:       '#16a34a',

  tagBg:         '#f5f5f5',
  tagText:       '#666666',
  summaryBg:     '#f5e6b3',
  summaryBorder: '#c9a227',

  badgeBg:       '#f0f0f0',
  badgeText:     '#999999',
} as const;

/** Symboles astrologiques unicode */
export const ASTRO_SYMBOLS: Record<string, string> = {
  // Signes
  belier: '♈', taureau: '♉', gemeaux: '♊', cancer: '♋',
  lion: '♌', vierge: '♍', balance: '♎', scorpion: '♏',
  sagittaire: '♐', capricorne: '♑', verseau: '♒', poissons: '♓',
  // Planètes
  soleil: '☉', lune: '☽', mercure: '☿', venus: '♀',
  mars: '♂', jupiter: '♃', saturne: '♄', uranus: '♅',
  neptune: '♆', pluton: '♇', noeud: '☊',
  // Aspects
  conjonction: '☌', opposition: '☍', carre: '□',
  trigone: '△', sextile: '✶', quinconce: '⚻',
  // Autres
  retrograde: '℞', rs: '⊙',
};

/**
 * Cherche un symbole astrologique correspondant au titre ou slug donné.
 * Retourne le symbole unicode ou null si aucun match.
 */
export function findAstroSymbol(text: string): string | null {
  const normalized = text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  for (const [key, symbol] of Object.entries(ASTRO_SYMBOLS)) {
    if (normalized.includes(key)) {
      return symbol;
    }
  }
  return null;
}
